import { render, staticRenderFns } from "./Call-Work-Info.vue?vue&type=template&id=20eea4a6&"
import script from "./Call-Work-Info.vue?vue&type=script&lang=js&"
export * from "./Call-Work-Info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports